const tabs = document.querySelectorAll('.home-tabs__tabs > li');

if (tabs.length > 0) {
    const tabContents = document.querySelectorAll('.home-tabs__content');
    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const tabRef = tab.dataset.tabRef;
            tabs.forEach(tab => tab.classList.remove('active'));
            tab.classList.add('active');
            tabContents.forEach(tabContent => {
                if (tabContent.dataset.tab === tabRef) {
                    tabContent.classList.add('active');
                } else {
                    tabContent.classList.remove('active');
                }
            });
        });
    });
}
